import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";

// styles
import withStyles from "@material-ui/core/styles/withStyles";
import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

// Sections for this page
import BodyTextSection from "./Sections/BodyTextSection.jsx";
import CommentsSection from "./Sections/CommentsSection.jsx";
import RelatedPostsSection from "./Sections/RelatedPostsSection.jsx";

const dashboardRoutes = [];

class BlogPost extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="Spiffy Ventures"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 300,
            color: "dark"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/shanghai.jpeg")}>
          <div className={classes.container} >
            <GridContainer alignItems="flex-end" style={{height:"450px"}}>
              <GridItem xs={12} sm={12} md={12} >
                <div style={{textAlign:"center"}}>
                    <h1 className={classes.title}>Distributed Development</h1>
                    <h4>Is a distributed team right for your project?</h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>     
                 <BodyTextSection />
          </div>
        </div>
        
        <div className={classes.container}>     
            <RelatedPostsSection />
        </div>
        
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(BlogPost);



// WEBPACK FOOTER //
// ./src/views/BlogPost/BlogPost.jsx